<template>
  <div class="robot-arm-docking">
    <div class="enable-auto-line">
      <span class="color-o-9 mr16 fs20">{{
        $translateLang('自动线对接')
      }}</span>
      <a-switch
        id="engraving_setting_auto_line_switch"
        v-model="formData.auto_line_enable"
        @change="handleAutoLineEnableChange"
      ></a-switch>
    </div>
    <div class="mt20" v-show="formData.auto_line_enable">
      <span id="span_8q1uqnuvur" class="fs14 color-o-9"
        >{{ $translateLang('桦桦自动线') }}：</span
      >
      <a-checkbox
        class="check"
        v-model="formData.huahua_auto_line"
      ></a-checkbox>
      <span class="color-o-4">{{
        $translateLang('（不兼容标签放板基准）')
      }}</span>
    </div>
    <robot-arm-setting
      :visible="formData.auto_line_enable"
      :enable="formData.enable"
      :robotic-arm-model="formData.robotic_arm_model"
      :robotic-options="roboticOptions"
      @update:enable="handleRobotArmEnableChange"
      @update:robotic-arm-model="handleRobotArmModelChange"
    ></robot-arm-setting>
  </div>
</template>

<script>
import RobotArmSetting from './robotArmSetting.vue'

export default {
  components: {
    RobotArmSetting,
  },
  props: {
    obj: {
      type: [Array, Object],
      default: () => {},
    },
    isShowSecondaryCatalog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        enable: false,
        robotic_arm_model: '',
        auto_line_enable: false,
        huahua_auto_line: false,
      },
      roboticOptions: [],
    }
  },
  watch: {
    obj() {
      if (this.obj) {
        // 直接使用共享对象，自动线对接与锯切雕刻机共用同一份机械臂数据
        this.$set(this.obj, 'old_robotic_arm_model', this.obj.robotic_arm_model)
        this.formData = this.obj
      }
    },
  },
  methods: {
    handleRobotArmEnableChange(value) {
      this.$set(this.formData, 'enable', value)
    },
    handleRobotArmModelChange(value) {
      this.$set(this.formData, 'robotic_arm_model', value)
    },
    // 获取所有机械臂模板
    getAllRobotArmModel() {
      this.$getByToken('/robotic_arm_models', { from: 'user' }, (res) => {
        if (res.status == 1) {
          this.roboticOptions = res.data.model_list.map((item) => ({
            ...item,
            label: item.model_name,
            value: item.robotic_arm_model,
          }))
          this.$emit('update:robotic-options', this.roboticOptions)
        }
      })
    },
    // 关闭自动线时仅关闭依赖自动线的设置
    handleAutoLineEnableChange(value) {
      if (!value) {
        this.$set(this.formData, 'huahua_auto_line', false)
      }
    },
  },
  mounted() {
    this.getAllRobotArmModel()
  },
}
</script>

<style lang="less" scoped>
.robot-arm-docking {
  padding: 10px 0 0 24px;
  .enable-auto-line {
    display: flex;
    align-items: center;
  }
  .file-type {
    margin-top: 40px;
  }
}
</style>
